(() => {
  // Rotating word + time stamp + tone. UI text animation only; no generated imagery.
  const hero = document.querySelector('[data-ww-rotor-host]');
  if (!hero) return;
  const word = hero.querySelector('[data-ww-rotor-word]');
  const stamp = hero.querySelector('[data-ww-rotor-stamp]');
  const steps = [
    { word: 'mornings', time: '07:20' },
    { word: 'Mondays', time: '08:05' },
    { word: 'meetings', time: '10:00' },
    { word: 'days', time: '07:00' }
  ];
  // Mert 2026-09-25: the line stays centred for every word; the word's box eases to the new word's width,
  // so "Good" glides a little instead of jumping (widths measured from the real font, no guesses).
  const measure = (text) => {
    const probe = word.cloneNode(); probe.removeAttribute('data-ww-rotor-word');
    probe.style.cssText = 'position:absolute;visibility:hidden;width:auto;min-width:0;white-space:nowrap;transition:none';
    probe.textContent = text; word.parentNode.appendChild(probe);
    const w = probe.getBoundingClientRect().width; probe.remove(); return Math.ceil(w);
  };
  const fit = () => { word.style.transition = 'none'; word.style.width = measure(word.textContent) + 'px'; void word.offsetWidth; word.style.transition = ''; };
  fit(); window.addEventListener('resize', fit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let i = steps.length - 1;
  const show = (step) => {
    word.classList.add('is-out');
    word.style.width = measure(step.word) + 'px';
    if (stamp) stamp.classList.add('is-out');
    window.setTimeout(() => {
      word.textContent = step.word;
      hero.dispatchEvent(new CustomEvent('ww:rotor', { detail: { word: step.word } }));
      if (stamp) stamp.textContent = step.time;
      word.classList.remove('is-out');
      if (stamp) stamp.classList.remove('is-out');
    }, 450);
  };
  let timer = window.setInterval(() => { i = (i + 1) % steps.length; show(steps[i]); }, 3400);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { window.clearInterval(timer); timer = null; }
    else if (!timer) { timer = window.setInterval(() => { i = (i + 1) % steps.length; show(steps[i]); }, 3400); }
  });
})();
